import { render, staticRenderFns } from "./ReporteProyeccionProduccion.vue?vue&type=template&id=10f5cb7b&scoped=true&"
import script from "./ReporteProyeccionProduccion.vue?vue&type=script&lang=js&"
export * from "./ReporteProyeccionProduccion.vue?vue&type=script&lang=js&"
import style0 from "./ReporteProyeccionProduccion.vue?vue&type=style&index=0&id=10f5cb7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5cb7b",
  null
  
)

export default component.exports